import { Button, DatePicker, Input, InputProps } from "antd";
import { API_DATE_FORMAT } from "../../config/date";

export interface FilterPros {
    type: 'search' | 'date-range';
    value: InputProps['value'],
    placeholder: string;
    onChange: (selectedKeys: React.Key[]) => void;
    onSubmit: () => void;
    onReset: () => void;
}

export const TableFilter = ({
    type,
    placeholder,
    value,
    onChange,
    onSubmit,
    onReset
}: FilterPros) => {
    if (type === 'search') {
        return (
            <div style={{ padding: 8, width: 180 }}>
                <Input
                    placeholder={placeholder}
                    value={value}
                    onChange={(e) => onChange(e.target.value ? [e.target.value] : [])}
                    onPressEnter={onSubmit}
                    allowClear
                    style={{ width: 160 }}
                />
                <div style={{ display: 'flex', gap: 8, justifyContent: 'space-between', marginTop: 8 }}>
                    <Button
                        disabled={!value}
                        type="text"
                        size="small"
                        style={{ color: value ? '#1677ff' : 'rgba(0, 0, 0, 0.25)' }}
                        onClick={onReset}
                    >
                        Reset
                    </Button>
                    <Button type="primary" size="small" onClick={onSubmit}>
                        OK
                    </Button>
                </div>
            </div>
        )
    }
    if (type === 'date-range') {
        const RangePicker = DatePicker.RangePicker;

        return (
            <div style={{ padding: 8 }}>
                <RangePicker
                    onChange={(dates) => {
                        if (!dates || dates.length !== 2) {
                            onChange([]);
                        } else {
                            onChange([
                                dates[0]?.format(API_DATE_FORMAT) || '',
                                dates[1]?.format(API_DATE_FORMAT) || '',
                            ]);
                        }
                    }}
                    value={value as any}
                    allowClear
                />
                <div style={{ display: 'flex', gap: 8, justifyContent: 'space-between', marginTop: 8 }}>
                    <Button
                        // @ts-ignore
                        disabled={!value?.[0]}
                        type="text"
                        size="small"
                        // @ts-ignore
                        style={{ color: value?.[0] ? '#1677ff' : 'rgba(0, 0, 0, 0.25)' }}
                        onClick={onReset}
                    >
                        Reset
                    </Button>
                    <Button type="primary" size="small" onClick={onSubmit}>
                        OK
                    </Button>
                </div>
            </div>
        )
    }
};
